import React, { Component, Fragment } from "react";
import { ReportGeneratorUtils } from "../../utils/reportGeneratorUtils";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import { themeService } from "../../../../theme/service/activeTheme.service";
import _ from "lodash";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import { dataFormatters } from "../../../../utils/dataFormatters";
import ReportInfoSection from "../../../../libraries/ReportGenerator/ReportInfoSection";
import {
  BRC_InertRetardersInspectionReportSectionSchemas,
  getFlattenedSpringMinMaxReadings,
  InertRetarderSpringMinMaxReadings,
} from "./BRC_InertRetardersInspectionReportSchema";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import { curdActions } from "../../../../reduxCURD/actions";
import { CRUDFunction } from "../../../../reduxCURD/container";

const {
  generalInfo,
  SpringReadingsTable,
  InitialSpringReadingsHeader,
  AdjustedSpringReadingsHeader,
  SpringMinTableSubHeader,
  SpringMaxTableSubHeader,
  SpringMinMaxReadings,
  getSpringReadingsData,
  getSpringMinMaxReadingsData,
} = BRC_InertRetardersInspectionReportSectionSchemas;

const SectionHeader = ({ title }) => {
  return (
    <div className={"section-header-a"} style={{ fontSize: "18px" }}>
      {title}
    </div>
  );
};

class ReportView extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {}
  render() {
    let reportData = this.props.reportData ? this.props.reportData : {};
    let { milepost, location, user, date, formSummary, springMinMaxReadingsLookupData } = reportData;
    if (!springMinMaxReadingsLookupData) springMinMaxReadingsLookupData = [];
    if (!formSummary) formSummary = {};

    let data = {
      location: location,
      user: user ? user.name : "",
      milepost: milepost,
      reportDate: dataFormatters.dateFormatter(date),
      ...formSummary,
      ...getFlattenedSpringMinMaxReadings(springMinMaxReadingsLookupData),
    };

    return (
      <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
        <ReportTitleSection title={`Inert Retarders Inspection Report`} fontSizeOverride={"30px"} centerTitle={true} />
        <ReportInfoSection
          fontSizeOverride={"24px"}
          rows={[
            {
              col1: {
                title: "Inspector",
                value: data.user,
              },
              col2: {
                title: "Date",
                value: data.reportDate,
              },
            },
            {
              col1: {
                title: "Location",
                value: data.location,
              },
              col2: {
                title: "Milepost",
                value: reportData.milepost,
              },
            },
          ]}
        />
        <span className="spacer"></span>
        <table className="table-bordered" style={{ fontSize: "18px", width: "100%" }}>
          <ReportTableSectionRenderer section={generalInfo} rowsData={[data]} />
        </table>

        <table className="table-bordered" style={{ fontSize: "18px", width: "100%" }}>
          <ReportTableSectionRenderer section={InitialSpringReadingsHeader} />
          <ReportTableSectionRenderer section={SpringReadingsTable} rowsData={getSpringReadingsData(data, "initial")} />
        </table>

        <table className="table-bordered" style={{ fontSize: "18px", width: "100%" }}>
          <ReportTableSectionRenderer section={AdjustedSpringReadingsHeader} />
          <ReportTableSectionRenderer section={SpringReadingsTable} rowsData={getSpringReadingsData(data, "adj")} />
        </table>

        <SectionHeader title={"Comments"} />
        <div style={{ border: "2px solid", padding: "5px", fontSize: "18px", height: "100px" }}>{data.com}</div>

        <span className="spacer"></span>
        <table className="table-bordered" style={{ fontSize: "18px", width: "100%" }}>
          <ReportTableSectionRenderer section={SpringMinTableSubHeader} />
          <ReportTableSectionRenderer section={SpringMinMaxReadings} rowsData={getSpringMinMaxReadingsData(data, "min")} />
          <ReportTableSectionRenderer section={SpringMaxTableSubHeader} />
          <ReportTableSectionRenderer section={SpringMinMaxReadings} rowsData={getSpringMinMaxReadingsData(data, "max")} />
        </table>
      </div>
    );
  }
}

class BRC_InertRetardersInspectionReport extends Component {
  constructor(props) {
    super(props);
    this.state = { inertReadingsAppLookups: [] };
    this.getSpringMinMaxReadingsFromAppLookup = this.getSpringMinMaxReadingsFromAppLookup.bind(this);
  }
  componentDidMount() {
    this.props.getApplicationlookupss(["brcInertReadings"]);
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.applicationlookupsActionType !== this.props.applicationlookupsActionType &&
      this.props.applicationlookupsActionType == "APPLICATIONLOOKUPSS_READ_SUCCESS" &&
      Array.isArray(this.props.applicationlookupss)
    ) {
      this.setState({ inertReadingsAppLookups: [...this.props.applicationlookupss] });
    }
  }

  getSpringMinMaxReadingsFromAppLookup(lookups = [], inspecDate = new Date()) {
    let latest = lookups
      .filter((lookup) => lookup.opt2 && lookup.opt2.createdDate)
      .map((lookup) => {
        lookup.date = new Date(lookup.opt2.createdDate);
        return lookup;
      })
      .filter((lookup) => lookup.date.getTime() <= inspecDate.getTime())
      .sort((a, b) => b.date.getTime() - a.date.getTime())[0];
    return latest ? latest.opt1 : [];
  }
  render() {
    const { props } = this;
    const { inspec, isPreview } = props;
    const { inertReadingsAppLookups } = this.state;

    if (isPreview) {
      const springMinMaxReadingsLookupData = this.getSpringMinMaxReadingsFromAppLookup(inertReadingsAppLookups, new Date());
      return <ReportView reportData={{ springMinMaxReadingsLookupData: springMinMaxReadingsLookupData }} isPreview={true} />;
    }

    let assets = ReportGeneratorUtils.getInspectionAssetsWithForm(inspec, () => true, "brcInertRetarderForm");
    return assets.map((asset, _i) => {
      const springMinMaxReadingsLookupData = this.getSpringMinMaxReadingsFromAppLookup(inertReadingsAppLookups, new Date(inspec.date));
      return (
        <ReportView
          key={_i}
          {...props}
          reportData={{
            formSummary: asset.summary,
            location: asset.assetName,
            date: ReportGeneratorUtils.getInspectionDate(inspec),
            user: ReportGeneratorUtils.getInspectionUser(inspec),
            milepost: asset.milepostWithMp,
            springMinMaxReadingsLookupData: springMinMaxReadingsLookupData,
          }}
        />
      );
    });
  }
}

const getApplicationlookupss = curdActions.getApplicationlookupss;
let actionOptions = {
  create: false,
  update: false,
  read: false,
  delete: false,
  others: {
    getApplicationlookupss,
  },
};

let variableList = {
  applicationlookupsReducer: { applicationlookupss: [] },
};

const BRC_InertRetardersInspectionReportContainer = CRUDFunction(
  BRC_InertRetardersInspectionReport,
  "brcInertRetarderReport",
  actionOptions,
  variableList,
  ["applicationlookupsReducer"],
);

export default BRC_InertRetardersInspectionReportContainer;



// WEBPACK FOOTER //
// ./src/components/Reports/BRC/InertRetardersInspectionReport/index.jsx